import React from 'react'
import Store from './src/Store'

export const wrapRootElement = ({ element }) => <Store>{element}</Store>
